import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator, toneModeEnumValidator } from '../../validators';

export const TranslateSentenceSchema = z.object({
  context: z.string().optional().describe('Additional context for translation'),
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  sentence: z.string().min(1),
  tone: toneModeEnumValidator.optional(),
});

export type ITranslateSentenceDto = z.infer<typeof TranslateSentenceSchema>;
